/* Diente — quick view modal.
   Loads the product's `quick-view` alternate template and injects it. */
(function () {
  'use strict';

  var modal = null;
  var body = null;
  var cache = {};

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'overlay overlay--center';
    modal.id = 'QuickView';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<button type="button" class="overlay__scrim" data-overlay-close aria-label="Inchide"></button>' +
      '<div class="modal" role="dialog" aria-modal="true" aria-label="Vezi rapid">' +
      '<button type="button" class="modal__close" data-overlay-close aria-label="Inchide">&#215;</button>' +
      '<div class="modal__body" data-quick-view-body></div>' +
      '</div>';

    document.body.appendChild(modal);
    body = modal.querySelector('[data-quick-view-body]');
    return modal;
  }

  function setLoading() {
    body.innerHTML = '<div class="quick-view quick-view--loading"><span></span></div>';
  }

  function bindVariantPicker(scope) {
    var data = scope.querySelector('[data-qv-variants]');
    if (!data) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (error) {
      return;
    }

    var selects = Array.prototype.slice.call(scope.querySelectorAll('[data-qv-option]'));
    var idInput = scope.querySelector('[data-qv-variant-id]');
    var addButton = scope.querySelector('[data-add-button]');

    function sync() {
      var chosen = selects.map(function (select) {
        return select.value;
      });

      var match = variants.find(function (variant) {
        return chosen.every(function (value, index) {
          return variant.options[index] === value;
        });
      });

      if (!match) return;

      idInput.value = match.id;
      addButton.disabled = !match.available;
      addButton.textContent = match.available
        ? window.theme.strings.addToCartLabel || addButton.textContent
        : addButton.textContent;

      var priceMount = scope.querySelector('[data-qv-price] .price__amount');
      if (priceMount) priceMount.textContent = window.Diente.formatAmount(match.price);

      var compareMount = scope.querySelector('[data-qv-price] .price__compare');
      if (compareMount) {
        if (match.compare_at_price > match.price) {
          var compareMountValue = compareMount.querySelector('[data-compare-value]') || compareMount;
            compareMountValue.textContent = window.Diente.formatAmount(match.compare_at_price);
          compareMount.hidden = false;
        } else {
          compareMount.hidden = true;
        }
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', sync);
    });
  }

  function open(url) {
    ensureModal();
    setLoading();
    window.Diente.openOverlay(modal);

    var request = cache[url]
      ? Promise.resolve(cache[url])
      : fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quick-view')
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            cache[url] = html;
            return html;
          });

    request
      .then(function (html) {
        body.innerHTML = html;
        bindVariantPicker(body);
        document.dispatchEvent(new CustomEvent('wishlist:render'));
      })
      .catch(function () {
        window.Diente.closeOverlay(modal);
        window.Diente.toast(window.theme.strings.cartError);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view]');
    if (!trigger) return;

    event.preventDefault();
    open(trigger.getAttribute('data-product-url'));
  });

  // A successful add from inside quick view should hand over to the cart drawer.
  document.addEventListener('cart:updated', function () {
    if (modal && modal.classList.contains('is-open')) window.Diente.closeOverlay(modal);
  });
})();